<section class="content">
  <h1> {{ description?.title }}</h1>

  <div class="mb-l" [innerHTML]="description?.description"></div>

  <mat-accordion>
    @for (preorder of preorders; track preorder) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="title red">
            {{ preorder.vendor }}
          </mat-panel-title>
          @if (preorder.show_dates) {
            <mat-panel-description>
              Bestellende am {{preorder.shop_end | date: 'EEEE, dd. LLLL yyyy H:mm'}}
              erreicht.
            </mat-panel-description>
          }
        </mat-expansion-panel-header>
        <table mat-table [dataSource]="preorder.products">
          <form [formGroup]="getForm(preorder.pre_order_period_id)">
            <!-- PZN Column -->
            <ng-container matColumnDef="pzn">
              <th mat-header-cell *matHeaderCellDef>PZN</th>
              <td mat-cell *matCellDef="let element"> {{element.id.pzn}} </td>
            </ng-container>
            <ng-container matColumnDef="unit">
              <th mat-header-cell *matHeaderCellDef>Einheit</th>
              <td mat-cell *matCellDef="let element"> {{element.unit}} </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Artikelbezeichnung</th>
              <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>
            <ng-container matColumnDef="comment">
              <th mat-header-cell *matHeaderCellDef>Anmerkungen</th>
              <td mat-cell *matCellDef="let element"> {{element.comment}} </td>
            </ng-container>
            <ng-container matColumnDef="aep">
              <th mat-header-cell *matHeaderCellDef>AEP</th>
              <td mat-cell *matCellDef="let element"> {{element.price_normal_aep | currency:'EUR':'symbol':'1.2-2'}} </td>
            </ng-container>
<!--            <ng-container matColumnDef="rap">-->
<!--              <th mat-header-cell *matHeaderCellDef>RAP</th>-->
<!--              <td mat-cell *matCellDef="let element"> {{element.price_tier1 | currency:'EUR':'symbol':'1.2-2'}} </td>-->
<!--            </ng-container>-->
            <ng-container matColumnDef="min_qty">
              <th mat-header-cell *matHeaderCellDef>ab Menge</th>
              <td mat-cell *matCellDef="let element"> 1 </td>
            </ng-container>
<!--            <ng-container matColumnDef="discount">-->
<!--              <th mat-header-cell *matHeaderCellDef>Vorteil auf RAP</th>-->
<!--              <td mat-cell *matCellDef="let element"> 3,05% </td>-->
<!--            </ng-container>-->
            <ng-container matColumnDef="qty">
              <th mat-header-cell *matHeaderCellDef>Bestellmenge</th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field class="mt-l preorders-input" appearance="outline">
                  <mat-label>Menge</mat-label>
                  <input matInput type="number" min="1" maxlength="4" class="text-center"
                         (change)="checkQty(getForm(preorder.pre_order_period_id), element.id.pzn, element.name)"
                         formControlName="{{element.id.pzn}}">
                </mat-form-field>
              </td>
            </ng-container>
          </form>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-action-row class="aic">
          <span><strong>Hinweis</strong>: {{ preorder.hint }} </span>
          @if (!isExpired(preorder.shop_end)) {
            <button mat-flat-button
                    color="primary"
                    class="mr-m preorder-button"
                    (click)="saveForm(preorder.pre_order_period_id)"
            >Vorbestellung speichern
            </button>
          }
        </mat-action-row>
        <p> {{ preorder.disclaimer }}</p>
      </mat-expansion-panel>
    }
  </mat-accordion>

  <p class="mt-l">
    Ihre Reservierungsbestätigung finden Sie nach Reservierungsschluss unter der Kachel "Archiv Grippeimpfstoffe".
  </p>

</section>
